/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUser } from './ApiUser';
import {
    ApiUserFromJSON,
    ApiUserFromJSONTyped,
    ApiUserToJSON,
    ApiUserToJSONTyped,
} from './ApiUser';

/**
 * 
 * @export
 * @interface ApiRiskRule
 */
export interface ApiRiskRule {
    /**
     * 
     * @type {number}
     * @memberof ApiRiskRule
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiRiskRule
     */
    handle?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiRiskRule
     */
    reason: string;
    /**
     * 
     * @type {string}
     * @memberof ApiRiskRule
     */
    details: string;
    /**
     * 
     * @type {string}
     * @memberof ApiRiskRule
     */
    content: string;
    /**
     * 
     * @type {number}
     * @memberof ApiRiskRule
     */
    weight: number;
    /**
     * 
     * @type {boolean}
     * @memberof ApiRiskRule
     */
    enabled: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ApiRiskRule
     */
    endTime?: Date;
    /**
     * 
     * @type {ApiUser}
     * @memberof ApiRiskRule
     */
    user?: ApiUser;
    /**
     * 
     * @type {Date}
     * @memberof ApiRiskRule
     */
    createdTime?: Date;
}

/**
 * Check if a given object implements the ApiRiskRule interface.
 */
export function instanceOfApiRiskRule(value: object): value is ApiRiskRule {
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('details' in value) || value['details'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('weight' in value) || value['weight'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function ApiRiskRuleFromJSON(json: any): ApiRiskRule {
    return ApiRiskRuleFromJSONTyped(json, false);
}

export function ApiRiskRuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiRiskRule {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'handle': json['handle'] == null ? undefined : json['handle'],
        'reason': json['reason'],
        'details': json['details'],
        'content': json['content'],
        'weight': json['weight'],
        'enabled': json['enabled'],
        'endTime': json['endTime'] == null ? undefined : (new Date(json['endTime'])),
        'user': json['user'] == null ? undefined : ApiUserFromJSON(json['user']),
        'createdTime': json['createdTime'] == null ? undefined : (new Date(json['createdTime'])),
    };
}

export function ApiRiskRuleToJSON(json: any): ApiRiskRule {
    return ApiRiskRuleToJSONTyped(json, false);
}

export function ApiRiskRuleToJSONTyped(value?: ApiRiskRule | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'handle': value['handle'],
        'reason': value['reason'],
        'details': value['details'],
        'content': value['content'],
        'weight': value['weight'],
        'enabled': value['enabled'],
        'endTime': value['endTime'] == null ? value['endTime'] : value['endTime'].toISOString(),
        'user': ApiUserToJSON(value['user']),
        'createdTime': value['createdTime'] == null ? value['createdTime'] : value['createdTime'].toISOString(),
    };
}

